import React, {Context, createContext, useState} from "react";

export let AddRootElement: Context<(e: JSX.Element, i: number) => number>
export let RemoveRootElement: Context<(e: number) => void>

export function Popups(){

    const [popups, setPopups] = useState([] as JSX.Element[])

    AddRootElement = createContext((e, i) => {
        let id = i;
        setPopups(popups => {
            console.log(popups)
            if (i === -1) id = popups.length;
            popups[id] = e;
            return [...popups];
        });
        console.log(id)
        return id;
    });

    RemoveRootElement = createContext((e) => {
        setPopups(p => {
            delete p[e];
            return [...p];
        })
    })

    return <>{popups.map((e, i) => <React.Fragment key={i}> {e} </React.Fragment>)}</>

}